<template>
  <input
    v-bind="$attrs"
    :max="max"
    :min="min"
    type="date"
    :value="formattedValue"
    v-on="listeners"
    @blur="handleBlur"
    @input="handleInput"
  />
</template>

<script>
export default {
  data() {
    return {
      applyFormatting: true,
    };
  },

  props: {
    convertTimezone: {
      type: Boolean,
      default: false,
    },
    max: {
      type: String,
      default: '2999-12-31',
    },
    min: {
      type: String,
      default: '1900-01-01'
    },
    value: {
      type: [Date, String, Number],
      default: "",
    },
  },

  computed: {
    formattedValue() {
      return this.applyFormatting
        ? this.formatTimestamp(this.value, {
            convertTZ: this.convertTimezone,
            format: "yyyy-MM-dd",
          })
        : this.value;
    },
    listeners() {
      const listeners = { ...this.$listeners };
      delete listeners.blur;
      delete listeners.input;
      return listeners;
    },
  },

  methods: {
    handleBlur(event) {
      const value = new Date(event.target.value);

      this.$emit(
        "input",
        new Date(value.getTime() - value.getTimezoneOffset() * -60000).toJSON()
      );

      this.$emit("blur", event);
      this.applyFormatting = true;
    },
    handleInput(event) {
      this.applyFormatting = false;
      this.$emit("input", event.target.value);
    },
  },
};
</script>